module.exports = __webpack_public_path__ + "static/media/consegna.87a847f8.svg";